import { useEffect } from "react";
import { useDaily } from "@daily-co/daily-react";
import { AudioVideoPreview } from "modules/audioVideo/components/Settings";
import { ResultContainer } from "../../../systemCheck/components/ResultContainer";
import { GeartestContext } from "../../types";
import "./styles.scss";

interface Props {
  spaceBetween?: boolean;
  context: GeartestContext;
}

export const VideoAudioTestView = ({
  spaceBetween,
  context,
}: Props): JSX.Element => {
  const daily = useDaily();

  useEffect(() => {
    const meetingState = daily?.meetingState();

    if (meetingState === "new" || meetingState === "left-meeting") {
      daily?.startCamera({ showLocalVideo: true });
    } else {
      daily?.setLocalVideo(true);
    }
  }, [daily]);

  return (
    <div
      className="mic-cam-check-container"
      data-testid="mic-cam-check-container"
      style={{
        justifyContent: spaceBetween ? "space-between" : "space-evenly",
        gap: "32px",
      }}
    >
      <AudioVideoPreview />
      <ResultContainer context={context} />
    </div>
  );
};
